import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchStateList } from "../../../redux/actions/commonActions";
import ErrorMsg from "../../form/errorMsg";
import { analyticalReportDownload } from "../../../redux/actions/dashboardAction";
import exportFromJSON from "export-from-json";
import CreatedPopup from '../../popups/CreatedPopUp';
import ErrorPopup from '../../popups/ErrorPopup';
import { AdminButton } from "../../buttons/versionHistoryBtn";

const AnalyticalReportModal = ({ show, handleClose, manufacturerViewData }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const fileName = "report";
  const exportType = exportFromJSON.types.csv;
  const [showInvoice, setShowInvoice] = useState(false);
  const [stateOptions, setStateOptions] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState("")
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("")


  useEffect(() => {
    dispatch(fetchStateList(onGetStateSuccess, onGetStateError));
  }, []);

  const onGetStateSuccess = (data) => {
    console.log(data);
    let newArr = data.data.data.states.map((ele) => ({
      value: ele.id,
      label: ele.name,
    }));
    setStateOptions(newArr);
    console.log();
  };

  const onGetStateError = (err) => {
    console.log(err);
  };

  const initialValues = {
    from_date: "",
    to_date: "",
    state_id: "",
  };

  const validationSchema = Yup.object().shape({});

  const onSubmit = (values) => {
    console.log(values);
    dispatch(analyticalReportDownload(values, onSuccess, onError));
  };

  const timeOutFnc = (data) => {
    setShowSuccessPopup(false);
   
  }

  const onSuccess = (data) => {
    console.log(data?.data?.data, "data");
    // setinvoiceTableData(data?.data?.data);
    exportFromJSON({ data: data?.data?.data?.data, fileName, exportType });
    setShowSuccessMsg(data?.data?.message);
    setShowSuccessPopup(true);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false)
  }

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    setShowErrorMsg(err?.data?.message)
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={handleClose}
        dialogClassName=""
        contentClassName="po-modal col-lg-5 col- mx-auto p-3  fn_Nunito"
      >
        <ModalHeader>
          <span className="Medium_Purple">
            Download Detailed Analytical Report
          </span>
        </ModalHeader>
        <ModalBody>
          <div>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
              enableReinitialize={true}
            >
              {({ setFieldValue, values }) => (
                <Form className="p-1">
                  <div className="d-flex mt-3">
                    <div className=" col-6 pe-2">
                      <span className="color_262c3d">From Date</span>
                      <Field
                        type="date"
                        style={{
                          border: "1px solid #747F9E",
                          borderRadius: "7px",
                        }}
                        className="py-1  p-2 w-100"
                        placeholder="Select Date"
                        // onfocus="(this.type = 'date')"
                        id="from_date"
                        name="from_date"
                      />
                    </div>
                    <div className=" col-6 ps-2">
                      <span className="color_262c3d">To Date</span>
                      <Field
                        type="date"
                        style={{
                          border: "1px solid #747F9E",
                          borderRadius: "7px",
                        }}
                        className="py-1  p-2 w-100"
                        placeholder="Select Date"
                        // onfocus="(this.type = 'date')"
                        id="to_date"
                        name="to_date"
                      />
                    </div>
                  </div>

                  <div className="w-100 mt-4">
                    <label className="w-100 color_262c3d fn_Nunito fs_14">
                      State
                    </label>
                    <Field name={"state_id"}>
                      {({ field, meta }) => (
                        <Select
                          {...field}
                          options={stateOptions}
                          styles={customStyles}
                          placeholder={"Select state"}
                          value={stateOptions.filter(
                            (s) => s.value == values.state_id
                          )}
                          onChange={(selected) => {
                            setSelectedState(selected?.value);
                            setFieldValue("districts", []);
                            setFieldValue("state_id", selected?.value);
                          }}
                        />
                      )}
                    </Field>
                    <ErrorMsg name="state_id" />
                  </div>

                  <div className="d-flex justify-content-end align-items-ccenter">
                    <AdminButton
                      width="100px"
                      color="rgba(255, 111, 91, 1)"
                      border="1px solid rgba(255, 111, 91, 1)"
                      background="white"
                      type="submit"
                      onClick={handleClose}
                    >
                      CLOSE
                    </AdminButton>
                    <AdminButton
                      width="150px"
                      color="white"
                      border="1px solid #7065e4"
                      background="#7065e4" 
                      type="submit"
                      onClick={() => {
                        handleClose();
                        setShowInvoice(true);
                      }}
                    >
                      SUBMIT
                    </AdminButton>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </ModalBody>
      </Modal>
      <CreatedPopup
        show={showSuccessPopup}
        title={showSuccessMsg}
      />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </>
  );
};

export default AnalyticalReportModal;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    // height: "43px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
